import * as React from 'react';
import { Company, getCompaniesList } from '../../../../api/Company';
import { useState } from 'react';
import FormSelectLabeled from '../../../common/form/SelectLabeled';
import { migrateProperty } from '../../../../api/Property';
import Button from '../../../common/form/Button';
import { useFetch } from '../../../../hooks/useFetch';
import { userIsCompanyManageUser, userIsPropertyManageUser, userIsSystemManageUser } from '../../../../utilities/identity';

interface Props {
    companiesList: Company[] | undefined;
    propertyId: number;
    setIsLoading: (isLoading: boolean) => void;
    setError: (error?: string) => void;
    currentCompanyId?: number;
}

const CompanyMigrationSection = (props: Props) => {
    const isUser =
    userIsCompanyManageUser() ||
    userIsPropertyManageUser() ||
    userIsSystemManageUser();
    const [destinationCompanyId, setDestinationCompanyId] = useState<number | undefined>(undefined);

    const { data: companiesList } = useFetch(() => getCompaniesList(), [], [] as Company[]);

    const sortedCompaniesList = companiesList && companiesList.length > 0
  ? companiesList.sort((a, b) => a.name.localeCompare(b.name))
  : [];

    const handleSubmit = async () => {
        if (
            window.confirm(
                'Are you sure you want to migrate this property?\n' +
                'Users of ONLY this property will move with it, but any users that are associated with multiple properties will lose their access to this property.\n\n' +
                'Checklist:\n' +
                'Step 1: Confirm the property has the same PMS / CRM / Access integrations.\n' +
                'Step 2: If property was previously on VUM, please verify PMS in Step 1 is correct, then re-sync property once moved.'
            )
        ) {
            props.setIsLoading(true);
            let result = await migrateProperty(props.propertyId, destinationCompanyId!);
            props.setError(result.error);
            props.setIsLoading(false);
            location.reload();
        }
    };

    return (
        <div className="row">
            <div className="col">
                <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                    <div style={{ flexGrow: 4 }}>
                        <FormSelectLabeled
                            selectProps={{
                                id: 'move-company',
                                name: 'moveCompany',
                                value: destinationCompanyId,
                                disabled: isUser
                            }}
                            labelProps={{
                                labelText: 'Move To...'
                            }}
                            selectOptions={
                                sortedCompaniesList === undefined
                                    ? []
                                    : sortedCompaniesList
                                          .filter(c => c.id !== props.currentCompanyId)
                                          .map(c => ({ value: c.id, label: c.name }))
                            }
                            onChange={(_name, value) =>
                                value && setDestinationCompanyId(value as number)
                            }
                        />
                    </div>
                    <div className="form-group">
                        <Button
                            text="Move Property"
                            addlClassName="btn-primary ml-4"
                            onClick={() => destinationCompanyId && handleSubmit()}
                            disabled={destinationCompanyId === undefined}
                            suppressBottomMargin={true}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CompanyMigrationSection;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/CompanyMigrationSection.tsx